/**
 * Invite limits and defaults — mirrored by backend constants in
 * `apps/backend/src/subscriptions/constants/` (DTO + service) and the DB CHECK
 * (`chk_trial_invites_trial_days`) — change together.
 */
export const TRIAL_DAYS_MIN = 1;
export const TRIAL_DAYS_MAX = 90;
export const TRIAL_DAYS_DEFAULT = 14;

export const VALID_DAYS_MIN = 1;
export const VALID_DAYS_MAX = 30;
export const VALID_DAYS_DEFAULT = 7;

/**
 * "Twój okres próbny kończy się…" mails go out this many days before the end —
 * mirrored by `DAYS_BEFORE_EXPIRY` in `billing-renewal-cron.job.ts` and
 * `DAYS_BEFORE_EXPIRY_MAX` in `billing-pre-expiration-reminder-cron.job.ts`.
 */
export const EXPIRATION_NOTICE_DAYS = 7;
export const URGENT_EXPIRATION_NOTICE_DAYS = 2;
